import ParentClass from './Parent.js';

class CaseStudy extends ParentClass {
    constructor(){
        super();
        const moduleClass = '.case-study-container';
        if(!super.runThisModule(moduleClass)) return;

        this.formModal = $("#formModal");
        this.formCTALink = $('.case-study--form-cta-link');

        this.bindClickCTAForm();

        this.formModal.on('wpcf7mailsent', '.wpcf7', (ev) => {
            this.formCTALink.unbind('click.ctaFormEvents');
            this.formCTALink[0].click();

            $(ev.delegateTarget).modal('hide');
            this.bindClickCTAForm();
        });

        this.initCaseStudySlider();
    }

    bindClickCTAForm(){
        this.formCTALink.bind("click.ctaFormEvents", (ev) => {
            ev.preventDefault();
            let row = $(ev.target).closest('.row');
            let modalBody = this.formModal.find('.modal-body');
            let formContent = row.find('.form-content').html();

            // Open form
            modalBody.html(formContent);
            this.formModal.modal();
        });
    }

    initCaseStudySlider() {
        const caseStudySlider = $('.case-study-slider__wrapper');

        if (caseStudySlider.length > 0) {
            $(document).ready(function() {
                caseStudySlider.slick({
                    rows: 0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    adaptiveHeight: true
                });
            });
        }
    }
}

jQuery(document).ready(function() {
    new CaseStudy();
});



// WEBPACK FOOTER //
// ./wp-content/themes/variscale/library/js/classes/CaseStudy.js